import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox } from "vue";
const _hoisted_1 = { class: "container-fluid p-4" };
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2" };
const _hoisted_3 = { class: "d-flex align-items-center gap-2" };
const _hoisted_4 = { class: "card border-0 shadow-sm mb-3" };
const _hoisted_5 = { class: "card-body" };
const _hoisted_6 = { class: "row g-3 mb-2" };
const _hoisted_7 = { class: "col-md-4" };
const _hoisted_8 = { class: "col-md-3" };
const _hoisted_9 = ["value"];
const _hoisted_10 = { class: "card border-0 shadow-sm" };
const _hoisted_11 = { class: "card-body" };
const _hoisted_12 = { class: "table-responsive" };
const _hoisted_13 = { class: "table table-hover align-middle" };
const _hoisted_14 = { key: 0 };
const _hoisted_15 = { key: 1 };
const _hoisted_16 = { class: "text-muted" };
const _hoisted_17 = {
    key: 0,
    class: "text-success"
};
const _hoisted_18 = {
    key: 1,
    class: "text-muted"
};
const _hoisted_19 = {
    key: 2,
    class: "text-muted d-block",
    style: { "max-width": "200px", "overflow": "hidden", "text-overflow": "ellipsis", "white-space": "nowrap" }
};
const _hoisted_20 = {
    key: 0,
    style: { "max-width": "200px", "overflow": "hidden", "text-overflow": "ellipsis", "white-space": "nowrap" }
};
const _hoisted_21 = {
    key: 1,
    class: "text-muted"
};
const _hoisted_22 = {
    key: 2,
    class: "text-muted"
};
const _hoisted_23 = {
    key: 0,
    style: { "max-width": "150px", "overflow": "hidden", "text-overflow": "ellipsis", "white-space": "nowrap" }
};
const _hoisted_24 = {
    key: 1,
    class: "text-muted"
};
const _hoisted_25 = {
    key: 2,
    class: "text-muted"
};
const _hoisted_26 = { class: "d-flex flex-wrap gap-1" };
const _hoisted_27 = {
    key: 0,
    class: "badge bg-light text-dark"
};
const _hoisted_28 = {
    key: 1,
    class: "badge bg-light text-dark"
};
const _hoisted_29 = {
    key: 2,
    class: "badge bg-light text-dark"
};
const _hoisted_30 = {
    key: 3,
    class: "badge bg-light text-dark"
};
const _hoisted_31 = {
    key: 4,
    class: "badge bg-light text-dark"
};
const _hoisted_32 = {
    key: 5,
    class: "text-muted"
};
const _hoisted_33 = { class: "text-end" };
const _hoisted_34 = { class: "btn-group" };
const _hoisted_35 = ["onClick"];
const _hoisted_36 = ["onClick"];
const _hoisted_37 = {
    key: 0,
    class: "modal fade show d-block",
    style: { "background": "rgba(0,0,0,0.5)" }
};
const _hoisted_38 = { class: "modal-dialog modal-xl" };
const _hoisted_39 = { class: "modal-content" };
const _hoisted_40 = { class: "modal-header" };
const _hoisted_41 = { class: "modal-title" };
const _hoisted_42 = ["disabled"];
const _hoisted_43 = {
    key: 0,
    class: "progress",
    style: { "height": "4px", "border-radius": "0" }
};
const _hoisted_44 = { class: "modal-body" };
const _hoisted_45 = {
    key: 0,
    class: "alert alert-warning"
};
const _hoisted_46 = { class: "row g-3" };
const _hoisted_47 = { class: "col-md-6" };
const _hoisted_48 = ["disabled"];
const _hoisted_49 = ["value"];
const _hoisted_50 = { class: "col-12" };
const _hoisted_51 = { class: "form-check" };
const _hoisted_52 = { class: "col-12" };
const _hoisted_53 = { class: "col-12" };
const _hoisted_54 = { class: "col-md-6" };
const _hoisted_55 = { class: "col-12" };
const _hoisted_56 = { class: "col-12" };
const _hoisted_57 = { class: "col-12" };
const _hoisted_58 = { class: "col-md-6" };
const _hoisted_59 = { class: "form-check" };
const _hoisted_60 = { class: "col-md-6" };
const _hoisted_61 = { class: "form-check" };
const _hoisted_62 = { class: "col-md-6" };
const _hoisted_63 = { class: "form-check" };
const _hoisted_64 = { class: "col-md-6" };
const _hoisted_65 = { class: "form-check" };
const _hoisted_66 = { class: "col-md-6" };
const _hoisted_67 = { class: "form-check" };
const _hoisted_68 = { class: "col-12" };
const _hoisted_69 = { class: "col-md-6" };
const _hoisted_70 = { class: "col-md-6" };
const _hoisted_71 = { class: "col-12" };
const _hoisted_72 = { class: "modal-footer" };
const _hoisted_73 = ["disabled"];
const _hoisted_74 = ["disabled"];
const _hoisted_75 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
import { ref, computed, onMounted, watch } from 'vue';
import adminLocationPoliciesService from '@/services/admin/location-policies.admin.service';
import adminLocationsService from '@/services/admin/locations.admin.service';
import { useAuthStore } from '@/store/auth';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AdminLocationPolicies',
    setup(__props) {
        const authStore = useAuthStore();
        const currentUser = computed(() => authStore.currentUser);
        const isSuperAdmin = computed(() => {
            const roleId = currentUser.value?.role_id;
            return roleId === 1 || roleId === '1';
        });
        const items = ref([]);
        const loading = ref(false);
        const search = ref('');
        const filterLocationId = ref('');
        const showForm = ref(false);
        const editing = ref(false);
        const formLoading = ref(false);
        const existingPolicyWarning = ref(false);
        const locationOptions = ref([]);
        const form = ref({
            id: null,
            location_id: '',
            reservation_recommended: false,
            reservation_notes: '',
            reservation_link: '',
            cancellation_deadline_hours: null,
            cancellation_policy: '',
            opening_hours: '',
            days_closed: '',
            accepts_cash: false,
            accepts_credit_card: false,
            accepts_debit_card: false,
            accepts_bank_transfer: false,
            accepts_digital_wallet: false,
            payment_notes: '',
            event_duration_hours: null,
            minimum_age: null,
            dress_code: ''
        });
        const filtered = computed(() => {
            let result = items.value;
            if (search.value) {
                const s = search.value.toLowerCase();
                result = result.filter(p => p.location?.name?.toLowerCase().includes(s) ||
                    p.reservation_notes?.toLowerCase().includes(s) ||
                    p.cancellation_policy?.toLowerCase().includes(s));
            }
            if (filterLocationId.value) {
                result = result.filter(p => String(p.location_id) === String(filterLocationId.value));
            }
            return result;
        });
        const formatDeadline = (hours) => {
            if (!hours)
                return '';
            const days = Math.floor(hours / 24);
            const remainingHours = hours % 24;
            if (days > 0) {
                return `${days} día${days > 1 ? 's' : ''}${remainingHours > 0 ? ` y ${remainingHours} hora${remainingHours > 1 ? 's' : ''}` : ''}`;
            }
            return `${hours} hora${hours > 1 ? 's' : ''}`;
        };
        const loadLocations = async () => {
            try {
                const response = isSuperAdmin.value
                    ? await adminLocationsService.list({ limit: 1000 })
                    : await adminLocationsService.listByUser(currentUser.value?.id || 0, { limit: 1000 });
                if (response?.success && response?.data) {
                    locationOptions.value = response.data.map(loc => ({
                        id: loc.id,
                        name: loc.name,
                        type: loc.type
                    }));
                }
            }
            catch (error) {
                console.error('Error loading locations:', error);
            }
        };
        const reload = async () => {
            loading.value = true;
            try {
                const userId = currentUser.value?.id;
                let response;
                // Si es super_admin (role_id = 1), listar todas las políticas
                // Si no, listar solo las del usuario actual
                if (isSuperAdmin.value) {
                    response = await adminLocationPoliciesService.list({ limit: 1000 });
                }
                else if (userId) {
                    response = await adminLocationPoliciesService.listByUser(userId, { limit: 1000 });
                }
                else {
                    items.value = [];
                    return;
                }
                if (response?.success && response?.data) {
                    items.value = response.data;
                }
            }
            catch (error) {
                console.error('Error loading policies:', error);
            }
            finally {
                loading.value = false;
            }
        };
        const openForm = async (policy) => {
            if (policy) {
                editing.value = true;
                form.value = {
                    id: policy.id,
                    location_id: String(policy.location_id),
                    reservation_recommended: policy.reservation_recommended,
                    reservation_notes: policy.reservation_notes || '',
                    reservation_link: policy.reservation_link || '',
                    cancellation_deadline_hours: policy.cancellation_deadline_hours,
                    cancellation_policy: policy.cancellation_policy || '',
                    opening_hours: policy.opening_hours || '',
                    days_closed: policy.days_closed || '',
                    accepts_cash: policy.accepts_cash,
                    accepts_credit_card: policy.accepts_credit_card,
                    accepts_debit_card: policy.accepts_debit_card,
                    accepts_bank_transfer: policy.accepts_bank_transfer,
                    accepts_digital_wallet: policy.accepts_digital_wallet,
                    payment_notes: policy.payment_notes || '',
                    event_duration_hours: policy.event_duration_hours,
                    minimum_age: policy.minimum_age,
                    dress_code: policy.dress_code || ''
                };
                existingPolicyWarning.value = false;
            }
            else {
                editing.value = false;
                form.value = {
                    id: null,
                    location_id: '',
                    reservation_recommended: false,
                    reservation_notes: '',
                    reservation_link: '',
                    cancellation_deadline_hours: null,
                    cancellation_policy: '',
                    opening_hours: '',
                    days_closed: '',
                    accepts_cash: false,
                    accepts_credit_card: false,
                    accepts_debit_card: false,
                    accepts_bank_transfer: false,
                    accepts_digital_wallet: false,
                    payment_notes: '',
                    event_duration_hours: null,
                    minimum_age: null,
                    dress_code: ''
                };
                // Verificar si ya existe una política para la locación seleccionada
                checkExistingPolicy();
            }
            showForm.value = true;
        };
        const checkExistingPolicy = async () => {
            if (!form.value.location_id) {
                existingPolicyWarning.value = false;
                return;
            }
            try {
                const response = await adminLocationPoliciesService.getByLocation(form.value.location_id);
                if (response?.success && response?.data) {
                    existingPolicyWarning.value = true;
                }
                else {
                    existingPolicyWarning.value = false;
                }
            }
            catch (error) {
                existingPolicyWarning.value = false;
            }
        };
        watch(() => form.value.location_id, () => {
            if (!editing.value) {
                checkExistingPolicy();
            }
        });
        const closeForm = () => {
            showForm.value = false;
            editing.value = false;
            formLoading.value = false;
            existingPolicyWarning.value = false;
        };
        const save = async () => {
            if (!form.value.location_id) {
                alert('Por favor selecciona una locación');
                return;
            }
            formLoading.value = true;
            try {
                const body = {
                    location_id: Number(form.value.location_id),
                    reservation_recommended: form.value.reservation_recommended,
                    reservation_notes: form.value.reservation_notes || null,
                    reservation_link: form.value.reservation_link || null,
                    cancellation_deadline_hours: form.value.cancellation_deadline_hours || null,
                    cancellation_policy: form.value.cancellation_policy || null,
                    opening_hours: form.value.opening_hours || null,
                    days_closed: form.value.days_closed || null,
                    accepts_cash: form.value.accepts_cash,
                    accepts_credit_card: form.value.accepts_credit_card,
                    accepts_debit_card: form.value.accepts_debit_card,
                    accepts_bank_transfer: form.value.accepts_bank_transfer,
                    accepts_digital_wallet: form.value.accepts_digital_wallet,
                    payment_notes: form.value.payment_notes || null,
                    event_duration_hours: form.value.event_duration_hours || null,
                    minimum_age: form.value.minimum_age || null,
                    dress_code: form.value.dress_code || null
                };
                console.log('💾 Guardando política:', { editing: editing.value, formId: form.value.id, body });
                let response;
                if (editing.value && form.value.id) {
                    // Si estamos editando, usar update
                    response = await adminLocationPoliciesService.update(form.value.id, body);
                }
                else {
                    // Para crear, usar updateOrCreate que maneja automáticamente si ya existe
                    // Esto es más eficiente que verificar primero
                    response = await adminLocationPoliciesService.updateOrCreate(form.value.location_id, body);
                }
                console.log('📥 Respuesta del servidor:', response);
                if (response?.success) {
                    closeForm();
                    await reload();
                }
                else {
                    const errorMsg = response?.message || 'Error al guardar la política';
                    console.error('❌ Error en respuesta:', errorMsg);
                    alert(errorMsg);
                }
            }
            catch (error) {
                console.error('❌ Error saving policy:', error);
                console.error('Detalles del error:', {
                    message: error?.message,
                    response: error?.response,
                    status: error?.response?.status,
                    data: error?.response?.data
                });
                const errorMsg = error?.response?.data?.message ||
                    error?.response?.data?.error ||
                    error?.message ||
                    'Error al guardar la política';
                alert(errorMsg);
            }
            finally {
                formLoading.value = false;
            }
        };
        const remove = async (id) => {
            if (!confirm('¿Estás seguro de eliminar esta política?'))
                return;
            try {
                console.log('🗑️ Eliminando política:', id);
                const response = await adminLocationPoliciesService.remove(id);
                console.log('📥 Respuesta eliminar:', response);
                if (response?.success) {
                    await reload();
                }
                else {
                    const errorMsg = response?.message || 'Error al eliminar la política';
                    console.error('❌ Error en respuesta:', errorMsg);
                    alert(errorMsg);
                }
            }
            catch (error) {
                console.error('❌ Error removing policy:', error);
                console.error('Detalles del error:', {
                    message: error?.message,
                    response: error?.response,
                    status: error?.response?.status,
                    data: error?.response?.data
                });
                const errorMsg = error?.response?.data?.message ||
                    error?.response?.data?.error ||
                    error?.message ||
                    'Error al eliminar la política';
                alert(errorMsg);
            }
        };
        onMounted(async () => {
            await loadLocations();
            await reload();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _cache[21] || (_cache[21] = _createElementVNode("div", null, [
                        _createElementVNode("h1", { class: "h3 mb-1" }, [
                            _createElementVNode("i", { class: "fas fa-file-alt text-primary me-2" }),
                            _createTextVNode("Políticas de Locaciones")
                        ]),
                        _createElementVNode("p", { class: "text-muted mb-0" }, "Gestión de políticas de reservas, cancelación, horarios y pagos por locación")
                    ], -1)),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("button", {
                            class: "btn btn-primary",
                            onClick: _cache[0] || (_cache[0] = ($event) => (openForm()))
                        }, [...(_cache[20] || (_cache[20] = [
                                _createElementVNode("i", { class: "fas fa-plus me-2" }, null, -1),
                                _createTextVNode("Nueva política ", -1)
                            ]))])
                    ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                _withDirectives(_createElementVNode("input", {
                                    class: "form-control",
                                    placeholder: "Buscar por nombre de locación...",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((search).value = $event))
                                }, null, 512), [
                                    [_vModelText, search.value]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                                _withDirectives(_createElementVNode("select", {
                                    class: "form-select",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((filterLocationId).value = $event))
                                }, [
                                    _cache[22] || (_cache[22] = _createElementVNode("option", { value: "" }, "Todas las locaciones", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locationOptions.value, (loc) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: loc.id,
                                            value: loc.id
                                        }, _toDisplayString(loc.name), 9, _hoisted_9));
                                    }), 128))
                                ], 512), [
                                    [_vModelSelect, filterLocationId.value]
                                ])
                            ])
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("table", _hoisted_13, [
                                _cache[29] || (_cache[29] = _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                        _createElementVNode("th", null, "Locación"),
                                        _createElementVNode("th", null, "Reservas"),
                                        _createElementVNode("th", null, "Cancelación"),
                                        _createElementVNode("th", null, "Horarios"),
                                        _createElementVNode("th", null, "Formas de pago"),
                                        _createElementVNode("th", {
                                            class: "text-end",
                                            style: { "width": "120px" }
                                        }, "Acciones")
                                    ])
                                ], -1)),
                                _createElementVNode("tbody", null, [
                                    (loading.value)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [...(_cache[23] || (_cache[23] = [
                                                _createElementVNode("td", {
                                                    colspan: "6",
                                                    class: "text-center p-4"
                                                }, [
                                                    _createElementVNode("span", { class: "spinner-border spinner-border-sm text-primary" }),
                                                    _createElementVNode("span", { class: "ms-2" }, "Cargando…")
                                                ], -1)
                                            ]))]))
                                        : (filtered.value.length === 0)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [...(_cache[24] || (_cache[24] = [
                                                    _createElementVNode("td", {
                                                        colspan: "6",
                                                        class: "text-center p-4 text-muted"
                                                    }, [
                                                        _createElementVNode("i", { class: "fas fa-inbox fa-2x mb-2 d-block" }),
                                                        _createTextVNode(" No hay políticas para mostrar ")
                                                    ], -1)
                                                ]))]))
                                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(filtered.value, (policy) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                    key: policy.id
                                                }, [
                                                    _createElementVNode("td", null, [
                                                        _createElementVNode("div", null, [
                                                            _createElementVNode("strong", null, _toDisplayString(policy.location?.name || '-'), 1)
                                                        ]),
                                                        _createElementVNode("small", _hoisted_16, _toDisplayString(policy.location?.type || ''), 1)
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                        (policy.reservation_recommended)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [...(_cache[25] || (_cache[25] = [
                                                                    _createElementVNode("i", { class: "fas fa-check-circle" }, null, -1),
                                                                    _createTextVNode(" Recomendadas ", -1)
                                                                ]))]))
                                                            : (_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[26] || (_cache[26] = [
                                                                    _createElementVNode("i", { class: "fas fa-times-circle" }, null, -1),
                                                                    _createTextVNode(" No requeridas ", -1)
                                                                ]))])),
                                                        (policy.reservation_notes)
                                                            ? (_openBlock(), _createElementBlock("small", _hoisted_19, _toDisplayString(policy.reservation_notes), 1))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                        (policy.cancellation_policy)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(policy.cancellation_policy), 1))
                                                            : (_openBlock(), _createElementBlock("div", _hoisted_21, "-")),
                                                        (policy.cancellation_deadline_hours)
                                                            ? (_openBlock(), _createElementBlock("small", _hoisted_22, _toDisplayString(formatDeadline(policy.cancellation_deadline_hours)), 1))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                        (policy.opening_hours)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(policy.opening_hours), 1))
                                                            : (_openBlock(), _createElementBlock("div", _hoisted_24, "-")),
                                                        (policy.days_closed && policy.days_closed !== 'Ninguno')
                                                            ? (_openBlock(), _createElementBlock("small", _hoisted_25, " Cerrado: " + _toDisplayString(policy.days_closed), 1))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                        _createElementVNode("div", _hoisted_26, [
                                                            (policy.accepts_cash)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Efectivo"))
                                                                : _createCommentVNode("", true),
                                                            (policy.accepts_credit_card)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_28, "Crédito"))
                                                                : _createCommentVNode("", true),
                                                            (policy.accepts_debit_card)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_29, "Débito"))
                                                                : _createCommentVNode("", true),
                                                            (policy.accepts_bank_transfer)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_30, "Transferencia"))
                                                                : _createCommentVNode("", true),
                                                            (policy.accepts_digital_wallet)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_31, "Digital"))
                                                                : _createCommentVNode("", true),
                                                            (!policy.accepts_cash && !policy.accepts_credit_card && !policy.accepts_debit_card && !policy.accepts_bank_transfer && !policy.accepts_digital_wallet)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_32, "-"))
                                                                : _createCommentVNode("", true)
                                                        ])
                                                    ]),
                                                    _createElementVNode("td", _hoisted_33, [
                                                        _createElementVNode("div", _hoisted_34, [
                                                            _createElementVNode("button", {
                                                                class: "btn btn-sm btn-outline-primary",
                                                                onClick: ($event) => (openForm(policy)),
                                                                title: "Editar"
                                                            }, [...(_cache[27] || (_cache[27] = [
                                                                    _createElementVNode("i", { class: "fas fa-edit" }, null, -1)
                                                                ]))], 8, _hoisted_35),
                                                            _createElementVNode("button", {
                                                                class: "btn btn-sm btn-outline-danger",
                                                                onClick: ($event) => (remove(policy.id)),
                                                                title: "Eliminar"
                                                            }, [...(_cache[28] || (_cache[28] = [
                                                                    _createElementVNode("i", { class: "fas fa-trash" }, null, -1)
                                                                ]))], 8, _hoisted_36)
                                                        ])
                                                    ])
                                                ]));
                                            }), 128))
                                ])
                            ])
                        ])
                    ])
                ]),
                (showForm.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                                _createElementVNode("div", _hoisted_40, [
                                    _createElementVNode("h4", _hoisted_41, _toDisplayString(editing.value ? 'Editar' : 'Nueva') + " política", 1),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn-close",
                                        onClick: closeForm,
                                        disabled: formLoading.value
                                    }, null, 8, _hoisted_42)
                                ]),
                                (formLoading.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [...(_cache[30] || (_cache[30] = [
                                            _createElementVNode("div", {
                                                class: "progress-bar progress-bar-striped progress-bar-animated bg-primary",
                                                style: { "width": "100%" }
                                            }, null, -1)
                                        ]))]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_44, [
                                    (existingPolicyWarning.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [...(_cache[31] || (_cache[31] = [
                                                _createElementVNode("i", { class: "fas fa-exclamation-triangle me-2" }, null, -1),
                                                _createTextVNode(" Esta locación ya tiene una política. Si creas una nueva, se reemplazará la existente. ", -1)
                                            ]))]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_46, [
                                        _createElementVNode("div", _hoisted_47, [
                                            _cache[33] || (_cache[33] = _createElementVNode("label", { class: "form-label" }, [
                                                _createTextVNode("Locación "),
                                                _createElementVNode("span", { class: "text-danger" }, "*")
                                            ], -1)),
                                            _withDirectives(_createElementVNode("select", {
                                                class: "form-select",
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((form.value.location_id) = $event)),
                                                disabled: editing.value
                                            }, [
                                                _cache[32] || (_cache[32] = _createElementVNode("option", { value: "" }, "Selecciona una locación", -1)),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locationOptions.value, (opt) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                        key: opt.id,
                                                        value: opt.id
                                                    }, _toDisplayString(opt.name) + " (" + _toDisplayString(opt.type) + ")", 9, _hoisted_49));
                                                }), 128))
                                            ], 8, _hoisted_48), [
                                                [_vModelSelect, form.value.location_id]
                                            ]),
                                            _cache[34] || (_cache[34] = _createElementVNode("small", { class: "text-muted" }, "Solo se puede crear una política por locación", -1))
                                        ]),
                                        _cache[52] || (_cache[52] = _createElementVNode("div", { class: "col-12" }, [
                                            _createElementVNode("hr"),
                                            _createElementVNode("h5", { class: "mb-3" }, [
                                                _createElementVNode("i", { class: "fas fa-calendar-check me-2" }),
                                                _createTextVNode("Reservas")
                                            ])
                                        ], -1)),
                                        _createElementVNode("div", _hoisted_50, [
                                            _createElementVNode("div", _hoisted_51, [
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((form.value.reservation_recommended) = $event)),
                                                    id: "reservation_recommended"
                                                }, null, 512), [
                                                    [_vModelCheckbox, form.value.reservation_recommended]
                                                ]),
                                                _cache[35] || (_cache[35] = _createElementVNode("label", {
                                                    class: "form-check-label",
                                                    for: "reservation_recommended"
                                                }, " Reservas recomendadas ", -1))
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_52, [
                                            _cache[36] || (_cache[36] = _createElementVNode("label", { class: "form-label" }, "Notas de reserva", -1)),
                                            _withDirectives(_createElementVNode("textarea", {
                                                class: "form-control",
                                                rows: "2",
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((form.value.reservation_notes) = $event)),
                                                placeholder: "Ej: Reservas recomendadas todo el año, especialmente en temporada alta..."
                                            }, null, 512), [
                                                [_vModelText, form.value.reservation_notes]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_53, [
                                            _cache[37] || (_cache[37] = _createElementVNode("label", { class: "form-label" }, "Enlace de reserva", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-control",
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((form.value.reservation_link) = $event)),
                                                placeholder: "https://..."
                                            }, null, 512), [
                                                [_vModelText, form.value.reservation_link]
                                            ])
                                        ]),
                                        _cache[53] || (_cache[53] = _createElementVNode("div", { class: "col-12" }, [
                                            _createElementVNode("hr"),
                                            _createElementVNode("h5", { class: "mb-3" }, [
                                                _createElementVNode("i", { class: "fas fa-times-circle me-2" }),
                                                _createTextVNode("Cancelación")
                                            ])
                                        ], -1)),
                                        _createElementVNode("div", _hoisted_54, [
                                            _cache[38] || (_cache[38] = _createElementVNode("label", { class: "form-label" }, "Plazo de cancelación (horas)", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "number",
                                                class: "form-control",
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((form.value.cancellation_deadline_hours) = $event)),
                                                placeholder: "48"
                                            }, null, 512), [
                                                [_vModelText, form.value.cancellation_deadline_hours]
                                            ]),
                                            _cache[39] || (_cache[39] = _createElementVNode("small", { class: "text-muted" }, "Ej: 48 horas = 2 días", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_55, [
                                            _cache[40] || (_cache[40] = _createElementVNode("label", { class: "form-label" }, "Política de cancelación", -1)),
                                            _withDirectives(_createElementVNode("textarea", {
                                                class: "form-control",
                                                rows: "3",
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((form.value.cancellation_policy) = $event)),
                                                placeholder: "Ej: No se realizará reembolso si la cancelación se realiza con menos de 48 horas de anticipación."
                                            }, null, 512), [
                                                [_vModelText, form.value.cancellation_policy]
                                            ])
                                        ]),
                                        _cache[54] || (_cache[54] = _createElementVNode("div", { class: "col-12" }, [
                                            _createElementVNode("hr"),
                                            _createElementVNode("h5", { class: "mb-3" }, [
                                                _createElementVNode("i", { class: "fas fa-clock me-2" }),
                                                _createTextVNode("Horarios")
                                            ])
                                        ], -1)),
                                        _createElementVNode("div", _hoisted_56, [
                                            _cache[41] || (_cache[41] = _createElementVNode("label", { class: "form-label" }, "Horario de apertura", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-control",
                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((form.value.opening_hours) = $event)),
                                                placeholder: "Ej: Recepción 24 horas"
                                            }, null, 512), [
                                                [_vModelText, form.value.opening_hours]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_57, [
                                            _cache[42] || (_cache[42] = _createElementVNode("label", { class: "form-label" }, "Días cerrado", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-control",
                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((form.value.days_closed) = $event)),
                                                placeholder: "Ej: Ninguno, Lunes, etc."
                                            }, null, 512), [
                                                [_vModelText, form.value.days_closed]
                                            ])
                                        ]),
                                        _cache[55] || (_cache[55] = _createElementVNode("div", { class: "col-12" }, [
                                            _createElementVNode("hr"),
                                            _createElementVNode("h5", { class: "mb-3" }, [
                                                _createElementVNode("i", { class: "fas fa-credit-card me-2" }),
                                                _createTextVNode("Formas de pago")
                                            ])
                                        ], -1)),
                                        _createElementVNode("div", _hoisted_58, [
                                            _createElementVNode("div", _hoisted_59, [
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((form.value.accepts_cash) = $event)),
                                                    id: "accepts_cash"
                                                }, null, 512), [
                                                    [_vModelCheckbox, form.value.accepts_cash]
                                                ]),
                                                _cache[43] || (_cache[43] = _createElementVNode("label", {
                                                    class: "form-check-label",
                                                    for: "accepts_cash"
                                                }, "Efectivo", -1))
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_60, [
                                            _createElementVNode("div", _hoisted_61, [
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((form.value.accepts_credit_card) = $event)),
                                                    id: "accepts_credit_card"
                                                }, null, 512), [
                                                    [_vModelCheckbox, form.value.accepts_credit_card]
                                                ]),
                                                _cache[44] || (_cache[44] = _createElementVNode("label", {
                                                    class: "form-check-label",
                                                    for: "accepts_credit_card"
                                                }, "Tarjeta de crédito", -1))
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_62, [
                                            _createElementVNode("div", _hoisted_63, [
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((form.value.accepts_debit_card) = $event)),
                                                    id: "accepts_debit_card"
                                                }, null, 512), [
                                                    [_vModelCheckbox, form.value.accepts_debit_card]
                                                ]),
                                                _cache[45] || (_cache[45] = _createElementVNode("label", {
                                                    class: "form-check-label",
                                                    for: "accepts_debit_card"
                                                }, "Tarjeta de débito", -1))
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_64, [
                                            _createElementVNode("div", _hoisted_65, [
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((form.value.accepts_bank_transfer) = $event)),
                                                    id: "accepts_bank_transfer"
                                                }, null, 512), [
                                                    [_vModelCheckbox, form.value.accepts_bank_transfer]
                                                ]),
                                                _cache[46] || (_cache[46] = _createElementVNode("label", {
                                                    class: "form-check-label",
                                                    for: "accepts_bank_transfer"
                                                }, "Transferencia bancaria", -1))
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_66, [
                                            _createElementVNode("div", _hoisted_67, [
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((form.value.accepts_digital_wallet) = $event)),
                                                    id: "accepts_digital_wallet"
                                                }, null, 512), [
                                                    [_vModelCheckbox, form.value.accepts_digital_wallet]
                                                ]),
                                                _cache[47] || (_cache[47] = _createElementVNode("label", {
                                                    class: "form-check-label",
                                                    for: "accepts_digital_wallet"
                                                }, "Billetera digital", -1))
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_68, [
                                            _cache[48] || (_cache[48] = _createElementVNode("label", { class: "form-label" }, "Notas de pago", -1)),
                                            _withDirectives(_createElementVNode("textarea", {
                                                class: "form-control",
                                                rows: "2",
                                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((form.value.payment_notes) = $event)),
                                                placeholder: "Ej: Transferencias deben realizarse al menos 72h antes del check-in..."
                                            }, null, 512), [
                                                [_vModelText, form.value.payment_notes]
                                            ])
                                        ]),
                                        _cache[56] || (_cache[56] = _createElementVNode("div", { class: "col-12" }, [
                                            _createElementVNode("hr"),
                                            _createElementVNode("h5", { class: "mb-3" }, [
                                                _createElementVNode("i", { class: "fas fa-info-circle me-2" }),
                                                _createTextVNode("Información adicional")
                                            ])
                                        ], -1)),
                                        _createElementVNode("div", _hoisted_69, [
                                            _cache[49] || (_cache[49] = _createElementVNode("label", { class: "form-label" }, "Duración del evento (horas)", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "number",
                                                class: "form-control",
                                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((form.value.event_duration_hours) = $event)),
                                                placeholder: "Ej: 3"
                                            }, null, 512), [
                                                [_vModelText, form.value.event_duration_hours]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_70, [
                                            _cache[50] || (_cache[50] = _createElementVNode("label", { class: "form-label" }, "Edad mínima", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "number",
                                                class: "form-control",
                                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((form.value.minimum_age) = $event)),
                                                placeholder: "Ej: 18"
                                            }, null, 512), [
                                                [_vModelText, form.value.minimum_age]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_71, [
                                            _cache[51] || (_cache[51] = _createElementVNode("label", { class: "form-label" }, "Código de vestimenta", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-control",
                                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((form.value.dress_code) = $event)),
                                                placeholder: "Ej: Casual, Formal, etc."
                                            }, null, 512), [
                                                [_vModelText, form.value.dress_code]
                                            ])
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_72, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-secondary",
                                        onClick: closeForm,
                                        disabled: formLoading.value
                                    }, "Cancelar", 8, _hoisted_73),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-primary",
                                        onClick: save,
                                        disabled: formLoading.value || !form.value.location_id
                                    }, [
                                        (formLoading.value)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_75))
                                            : _createCommentVNode("", true),
                                        _createTextVNode(" " + _toDisplayString(editing.value ? 'Actualizar' : 'Crear'), 1)
                                    ], 8, _hoisted_74)
                                ])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
